module.exports = __webpack_public_path__ + "assets/img/fblogo.14150615.png";